import { render } from "./KryptonFormError.vue?vue&type=template&id=35406d5c&lang=pug"
import script from "./KryptonFormError.vue?vue&type=script&lang=js"
export * from "./KryptonFormError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__